(()=> {

  /**
   * Add event click.
   */
  let filterItems = document.querySelectorAll(".js-filter-item");
  filterItems.forEach(filter => {
    filter.addEventListener("click", handleClickFilterItem);
  })

  /**
   * Get list of filters in a array.
   * Example: /collections/collection_name/color_red+size_medium
   */
  function getFiltersList() {
    // Not exit filter.
   if( window.location.toString().split("/").length <= 5){
    return false;
   }

   // filters exist.
   return window.location.toString().split("/")[5].split("+")
  }

  function setFiltersList(group, tag) {
    let haveChanges = false;
    let filtersList = getFiltersList()

    if(filtersList.length >= 1) {

      filtersList.forEach((filter, index) => {
        if(filter.startsWith(group)) {
          filtersList[index] = tag
          haveChanges = true;
        }
      });

      if(haveChanges === false) {
        filtersList.push(tag)
      }

      goNewFilter(filtersList.join("+"))
    } else {
      goNewFilter(tag);
    }
  }

  const keyCookie = Cookies.get('key');

  function goNewFilter(filters){
    if (keyCookie) {
      window.location.href = `/collections/${location.pathname.split("/")[2]}/${filters}/?k=${keyCookie}&cache=false`;
    } else {
      window.location.href = `/collections/${location.pathname.split("/")[2]}/${filters}`;
    }
  }

  /**
   *  Handle click event.
   * @param {*} evt
   */
  function handleClickFilterItem(evt) {
    evt.preventDefault();

    let filterGroup = evt.target.dataset.group;
    let filterTag = evt.target.dataset.taghandle;

    setFiltersList(filterGroup, filterTag);
    console.log("doosestudio", filterGroup, filterTag);
  }

})();